import {Component, OnInit} from '@angular/core';
import {ContactMethodResponse} from "../../../models/Common/contactMethodResponse";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CurrencyResponse} from "../../../models/Common/currencyResponse";
import {NgxSpinnerService} from "ngx-spinner";
import {CommonService} from "../../../services/common.service";
import {Router} from "@angular/router";
import swal from "sweetalert2";
import {AccountService} from "../../../services/account.service";
import {createPaymentForm, latinCharactersValidator} from "../../../helper/payment-form-helper";

@Component({
  selector: 'app-external-paymentinfo',
  templateUrl: './external-paymentinfo.component.html',
  styleUrls: ['./external-paymentinfo.component.scss']
})
export class ExternalPaymentinfoComponent implements OnInit {

  contactMethods: ContactMethodResponse[] = [];

  paymentInfoForm: FormGroup = createPaymentForm();
  currency: CurrencyResponse[] = [];

  constructor(private spinner: NgxSpinnerService,
              private accountService: AccountService,
              private commonService: CommonService,
              private router: Router) {

    this.spinner.show().then(_ => {});
    Promise.all([
      this.loadContactMethods(),
      this.loadCurrency(),
    ]).finally(() => this.spinner.hide());
  }

  loadCurrency() {

    return new Promise<void>((resolve, reject) => {
      this.commonService.getCurrency().subscribe({
        next: (response) => {
          this.currency = response.item || [];
          resolve();
        },
        error: (error) => {
          console.error("Error loading currency methods", error);
          reject(error);
        }
      });
    })


  }

  async ngOnInit() {
    await this.spinner.show();
    Promise.all([
      this.loadContactMethods(),
    ]).finally(() => this.spinner.hide());
  }

  loadContactMethods() {

    return new Promise<void>((resolve, reject) => {
      this.commonService.getContactMethod().subscribe({
        next: (response) => {
          this.contactMethods = response.item || [];
          resolve();
        },
        error: (error) => {
          console.error("Error loading contact methods", error);
          reject(error);
        }
      })
    });
  }


  async onSubmit() {
    if (this.paymentInfoForm.invalid) {


      if (this.paymentInfoForm.invalid) {
        Object.keys(this.paymentInfoForm.controls).forEach(key => {
          const control = this.paymentInfoForm.get(key);
          if (control instanceof FormGroup) {
            Object.keys(control.controls).forEach(innerKey => {
              control.get(innerKey)?.markAsTouched();
            });
          } else {
            control?.markAsTouched();
          }
        });
      }

      await swal.fire({
        title: 'Form Invalid',
        html: `Please correct the invalid field.`,
        icon: 'warning',
        confirmButtonText: 'OK',
      });


    } else {
      const formData = this.paymentInfoForm.value;



      await this.spinner.show();

      this.accountService.addPaymentInfo(formData).subscribe({
        next: async (response) => {
          await this.spinner.hide();
          if (response.result) {

            await swal.fire({
              title: 'The payment info  has been created successfully.',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => {
              this.router.navigate(['/external-contact']);
            });
          } else {
            await swal.fire({
              title: response.messages?.join(','),
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        },
        error: (_) => {
          this.spinner.hide();
        }
      });
    }
  }

  getInvalidFields(form: FormGroup): string[] {
    const invalidFields: string[] = [];
    Object.keys(form.controls).forEach(key => {
      const control = form.get(key);
      if (control instanceof FormGroup) {
        invalidFields.push(...this.getInvalidFields(control));
      } else if (control && control.invalid) {
        invalidFields.push(key);
      }
    });
    return invalidFields;
  }

  formABAChange() {
      const iban = <FormControl>this.paymentInfoForm.get('iban');
      const aba = <FormControl>this.paymentInfoForm.get('aba');
      if (aba.value) {
        iban.setValidators([
          Validators.maxLength(100),
          latinCharactersValidator(/^[A-Za-z0-9 .,'-]+$/)
        ]);
      }
      else {
        iban.setValidators([
          Validators.required,
          Validators.maxLength(100),
          latinCharactersValidator(/^[A-Za-z0-9 .,'-]+$/)
        ]);
      }
      iban.updateValueAndValidity();
    }

    formIBANChange() {
      const iban = <FormControl>this.paymentInfoForm.get('iban');
      const aba = <FormControl>this.paymentInfoForm.get('aba');
      if (iban.value) {
        aba.setValidators([
          Validators.maxLength(100),
          latinCharactersValidator(/^[A-Za-z0-9 .,'-]+$/)
        ]);
      }
      else {
        aba.setValidators([
          Validators.required,
          Validators.maxLength(100),
          latinCharactersValidator(/^[A-Za-z0-9 .,'-]+$/)
        ]);
      }
      aba.updateValueAndValidity();
    }
}
